import React from "react";
import "../InvestmentPage/InvestmentSection.css";
import AboutImage from "../../Image/FPOImgae/ERMImage.png";

export default function EnterpriseRiskSection() {
  return (
    <section className="fpo-excellence-section">
      <div className="fpo-excellence-container">

        {/* LEFT – IMAGE */}
        <div className="fpo-excellence-col fpo-excellence-left">
          <div className="fpo-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Financial Process Outsourcing"
              className="fpo-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="fpo-excellence-col fpo-excellence-right">
          <div className="fpo-excellence-content">

            <h2 className="fpo-excellence-title">
             Enterprise Risk Management
            </h2>

            <p className="fpo-excellence-text">
              Changing economic, geopolitical, environmental, and health environments, along with greater compliances and SOPs, have raised risk function load,  risk identification, mitigation, and risk-to-opportunity conversion.

Every risk may be reduced and converted into an opportunity, yet risk management is frequently disregarded and deemed “unimportant.” With every growth and development, risks and inefficiencies arise, allowing for success cycles across all domains and recognising new possibilities to pursue Cost-cutting and pitfalls.

Risk assessment is not a strategy, but it is one of the finest instruments along with regulatory compliance administration to drive progress and assist firms accomplish their objectives. Correct risk mapping and creating a risk appetite is crucial to future organizational success.
            </p>

            {/* SERVICES LIST */}
            <ul className="fpo-excellence-list">
 
            </ul>

          </div>
        </div>

      </div>
      <p>         
 Densat ERM advantages
Integrating risk assessment into corporate and IT activities improves risk management by building a risk-focused culture.
Standardized risk reporting assists enterprises with lengthy metrics and assessment.
Organizations may enhance focus and risk perspective in several areas.
Greater attention on business risk may result in more efficient resource utilization, such as limiting endpoint security licensing to the most accessible and vital systems.
Highly regulated firms may strengthen regulatory and compliance cooperation across business goals.
 
The professional team at Densat FPO partners with client managements and boards to enable them to effectively chalk out the various possible risks, map them on a heatmap with impact and probability scale and list down the SOP’s for effective countering of the risks and identification of mitigating strategies. We also help our clients in identifying opportunities and effective cost optimization strategies. Densat has finance professionals who deep dive on the financial statements and bring out ideas to bring down Non Value Ads and increase the utilization of every dollar spent. Densat Risk optimization also brings about key processes and systems to effectively identify and manage credit, operational, economic and market risks.we help in turning risks into opportunities
</p>
    </section>
  );
}
